<template>
  <div class="vdp__container grid">
    <div
      class="vdp__button_wrapper r-margin-10"
      v-if="params.type === 'rangedate'"
    >
      <button class="vdp__buttons r-margin-5" v-on:click="clickToday">
        <span>Сегодня</span>
      </button>
      <button class="vdp__buttons r-margin-5" v-on:click="clickYesterday">
        <span>Вчера</span>
      </button>
      <button class="vdp__buttons r-margin-5" v-on:click="clickWeek">
        <span>Неделя</span>
      </button>
      <button class="vdp__buttons" v-on:click="clickMonth">
        <span>Месяц</span>
      </button>
    </div>
    <div class="vdp__input_wrapper grid cross-center">
      <input
        type="text"
        class="vdp__input vdp__input-start"
        :class="{ 'vdp__input-active': openFromInput === 'start' && isVisible }"
        :value="dateStart === null ? '' : dateStart.format(params.format)"
        :placeholder="params.placeholderStart"
        v-on:click="e => e.stopPropagation()"
        v-on:focus.prevent="showCalendar('start')"
        readonly
      />
      <b-icon icon="arrow-right" size="is-small"></b-icon>
      <input
        type="text"
        class="vdp__input vdp__input-end"
        :class="{ 'vdp__input-active': openFromInput === 'end' && isVisible }"
        :value="dateEnd === null ? '' : dateEnd.format(params.format)"
        :placeholder="params.placeholderEnd"
        v-show="params.type === 'rangedate'"
        v-on:click="e => e.stopPropagation()"
        v-on:focus.prevent="showCalendar('end')"
        readonly
      />

      <div v-bind:class="{ 'vdp-show': isVisible }" class="vdp">
        <div class="vdp__wrapper">
          <div class="vdp__calendar" v-on:click="e => e.stopPropagation()">
            <div class="vdp__calendar_head">
              <div class="vdp__calendar_head_month">
                <i
                  class="prev el-icon-arrow-left"
                  v-on:click.prevent="changeViewDate('month', 'subtract')"
                ></i>
                <span>{{ viewDate.format("MMMM YYYY") }}</span>
                <i
                  class="next el-icon-arrow-right"
                  v-on:click.prevent="changeViewDate('month', 'add')"
                ></i>
              </div>
            </div>
            <div class="vdp__calendar_body">
              <div class="vdp__calendar_m">
                <div class="vdp__calendar_m_w">
                  <div
                    v-for="day in weekShortDays"
                    :key="day"
                    class="vdp__calendar_m_w_n"
                  >
                    {{ day }}
                  </div>
                </div>
              </div>
              <!-- Calendar month days -->
              <div class="vdp__calendar_days">
                <!-- Render "empty days" -->
                <div
                  v-for="(day, index) in viewDate
                    .clone()
                    .startOf('month')
                    .weekday()"
                  :key="index"
                  class="vdp__calendar_days_day-empty"
                ></div>

                <!-- Render month days -->
                <div
                  v-for="(day, index) in viewDate.daysInMonth()"
                  :key="index + 'day'"
                  :class="dayClass(day)"
                  v-on:click.prevent="setActiveDate(day)"
                >
                  {{ day }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "map-calendar",
  props: {
    options: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      params: {},
      openFromInput: "start",
      trigger: "start",
      viewDate: null,
      dateStart: null,
      dateEnd: null,
      weekShortDays: moment.weekdaysShort(),
      isVisible: false,
      eventNamespace: btoa(Math.random())
    };
  },
  computed: {
    dayClass: function() {
      return dayNum => {
        let dayClass = "",
          elDate = moment(
            this.viewDate.format("YYYY-MM") +
              "-" +
              (dayNum < 10 ? "0" + dayNum : dayNum)
          );
        if (
          (elDate.isSame(this.dateEnd, "day") &&
            this.params.type === "rangedate") ||
          elDate.isSame(this.dateStart, "day")
        ) {
          dayClass = "active ";
        }
        //Add class for between dates
        if (
          this.params.type === "rangedate" &&
          elDate.isAfter(this.dateStart, "day") &&
          elDate.isBefore(this.dateEnd, "day")
        ) {
          dayClass += "between ";
        }

        //Add class for disabled dates
        //Check max and min dates
        if (
          (typeof this.params.minDate === "object" &&
            elDate.isBefore(this.params.minDate)) ||
          (typeof this.params.maxDate === "object" &&
            elDate.isAfter(this.params.maxDate))
        ) {
          dayClass += "disabled";
        }
        return dayClass + " vdp__calendar_days_day";
      };
    }
  },
  mounted() {
    window.document.addEventListener("click", e => this.hideCalendar(e));
    //Hide calendar on show another calendar at page
    window.document.addEventListener("vdp-show", e => this.hideCalendar(e));
  },
  beforeCreate() {
    //set default locale
    moment.locale("ru");
  },
  created() {
    //Merge user options with default params
    this.params = Object.assign(
      {
        type: "date", // || rangedate
        startDate: null, //startDate
        endDate: null, //endDate
        locale: "ru",
        format: "YYYY.MM.DD", //Display date format
        placeholderStart: "Start date",
        placeholderEnd: "End date",
        minDate: null, //min available moment date
        maxDate: null, //max available moment date
        firstDayOfWeek: moment.localeData().firstDayOfWeek() //first number day of the week
      },
      this.options
    );

    moment.locale(this.params.locale);
    //Current view date in calendar
    this.viewDate =
      this.params.startDate === null ? moment() : this.params.startDate.clone();
    //Selected date - view on top
    this.dateStart = this.params.startDate;
    this.dateEnd = this.params.endDate;
    // update day names order by firstDayOfWeek
    if (this.params.firstDayOfWeek !== 0) {
      let i = this.params.firstDayOfWeek,
        weekShortDays = this.weekShortDays.map(d => d);
      while (i > 0) {
        weekShortDays.push(weekShortDays.shift());
        i--;
      }
      this.weekShortDays = weekShortDays;
    }
  },
  methods: {
    /**
     * Show calendar and trigger vdp-show event
     * @param {String} type calendar type start/end
     * @returns {void}
     */
    showCalendar(type) {
      this.openFromInput = type;
      this.triggerWindowEvent();
      this.$emit("vdp-show");
      this.isVisible = true;
    },
    /**
     * Hide calendar, set initial viewDate state
     * @returns {void}
     */
    hideCalendar(event) {
      if (this.isVisible) {
        this.$emit("vdp-hide");
        this.viewDate =
          this.dateStart === null ? moment() : this.dateStart.clone();
        this.isVisible = false;
      }
    },
    /**
     * Trigger custom event at window.document
     * need for close other already opened calendars at page
     * @returns {void}
     */
    triggerWindowEvent() {
      if (typeof window === "object") {
        window.document.dispatchEvent(new CustomEvent("vdp-show"));
      }
    },
    /**
     * Set next or prev date by params
     * @param  {Object} event    jQuery event
     * @param  {String} calendar end or start type
     * @param  {String} dateType day or week or month or year
     * @param  {String} action add\subtract
     * @returns {void}
     */
    changeViewDate(dateType = "day", action = "add") {
      this.viewDate = moment(this.viewDate[action](1, dateType));
    },

    /**
     * Emit new date values to parent component
     * @returns {void}
     */
    emitValues() {
      this.$emit("vdp-change", {
        startDate: this.dateStart,
        endDate: this.dateEnd,
        trigger: this.trigger
      });
    },
    /**
     * Set active date after click on day in calendar
     * @param {String} dayNum  day number
     * @returns {void}
     */
    setActiveDate(dayNum) {
      let params = this.params,
        date = moment(
          this.viewDate.format("YYYY-MM") +
            "-" +
            (String(dayNum).length === 1 ? "0" + dayNum : dayNum)
        );

      //Check max and min dates
      if (
        (typeof params.minDate === "object" && date.isBefore(params.minDate)) ||
        (typeof params.maxDate === "object" && date.isAfter(params.maxDate))
      )
        return;

      if (params.type === "rangedate") {
        if (this.openFromInput === "start") {
          if (this.dateEnd) {
            this.openFromInput = "end";
            this.dateStart = date;
          } else {
            if (date.isAfter(this.dateEnd, "day")) {
              this.dateEnd = date;
              this.dateStart = date.clone().add(1, "day");
            } else {
              this.dateStart = date;
            }
          }
          this.trigger = "start";
          //Dont forgot date is immutable moment object clone it
          this.viewDate = date.clone();
          this.emitValues();
        } else {
          if (this.dateStart === null) {
            this.dateStart = date;
            this.openFromInput = "start";
          } else {
            if (date.isBefore(this.dateStart, "day")) {
              this.dateStart = date;
            } else {
              this.dateEnd = date
                .milliseconds(0)
                .second(59)
                .minute(59)
                .hour(23);
            }
          }
          this.trigger = "end";
          this.hideCalendar(event);
          //Dont forgot date is immutable moment object clone it
          this.viewDate = date.clone();
          this.emitValues();
        }
      } else {
        this.dateStart = date;
        //Dont forgot date is immutable moment object clone it
        this.viewDate = date.clone();
        this.emitValues();
      }
    },
    clickToday() {
      this.trigger = "end";
      this.dateEnd = moment()
        .millisecond(0)
        .second(59)
        .minute(59)
        .hour(23);

      this.dateStart = moment()
        .millisecond(0)
        .second(0)
        .minute(0)
        .hour(0);

      this.emitValues();
    },
    clickYesterday() {
      this.trigger = "end";
      this.dateEnd = moment()
        .add(-1, "days")
        .millisecond(0)
        .second(59)
        .minute(59)
        .hour(23);

      this.dateStart = moment()
        .add(-1, "days")
        .millisecond(0)
        .second(0)
        .minute(0)
        .hour(0);

      this.emitValues();
    },

    clickWeek() {
      this.trigger = "end";
      this.dateEnd = moment()
        .millisecond(0)
        .second(59)
        .minute(59)
        .hour(23);

      this.dateStart = moment()
        .add(-6, "days")
        .millisecond(0)
        .second(0)
        .minute(0)
        .hour(0);

      this.emitValues();
    },

    clickMonth() {
      this.trigger = "end";
      this.dateEnd = moment()
        .millisecond(0)
        .second(59)
        .minute(59)
        .hour(23);

      this.dateStart = moment()
        .add(-1, "months")
        .subtract(-1, "days")
        .millisecond(0)
        .second(0)
        .minute(0)
        .hour(0);

      this.emitValues();
    }
  },
  watch: {
    options: {
      handler: function(val, oldVal) {
        this.dateStart = val.startDate;
        this.dateEnd = val.endDate;
        this.viewDate = val.startDate.clone();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
$orange: #537bdb;
$mainColor: $orange;
$textColor: #999;
$cloud: #ecf0f1;
.vdp {
  z-index: 30;
  width: 0;
  height: 0;
  font-family: "Avenir", "Arial", sans-serif;
  &-show {
    width: auto;
    height: auto;
    position: absolute;
    top: -10px;
    left: 0;
    & .vdp__wrapper {
      position: absolute;
      overflow: inherit;
      max-width: 600px;
      width: 320px;
      max-height: 520px;
      opacity: 1;
      display: block;
      border-radius: 0;
    }
    & .dt-modal_wrapper {
      z-index: 200;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
    }
  }
  &__container {
    position: relative;
  }
  &__button,
  &__input {
    &_wrapper {
      padding: 5px;
      font-size: 13px;
      border: 1px solid rgba(32, 36, 56, 0.2);
      border-radius: 4px;
      max-width: 320px;
      display: flex;
      position: relative;
      top: 0;
      left: 0;
      flex-wrap: nowrap;
    }
    height: 20px;
    width: 80px;
    border: none;
    color: #4f566b;
    font-weight: 500;
    text-align: center;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 12px 0;
    flex: 1;
    transition: all 0.25s ease;
    &-end {
      margin-left: 5px;
    }
    &:focus,
    &-active {
      outline: none;
      background-color: $mainColor;
      color: #ffffff;
    }
  }
  &__buttons {
    line-height: 0;
    border: 0px;
    border-radius: 5px;
    background: transparent;
    color: #4f566b;
    font-family: "Avenir", "Arial", sans-serif;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    transition: all 0.5s ease;
    &:focus,
    &-active {
      color: $mainColor;
      &:hover {
        background-color: transparent;
      }
    }
    &:hover {
      background-color: rgba(83, 123, 219, 0.15);
    }
  }
  &__footer {
    &_close {
      box-sizing: border-box;
      cursor: pointer;
      font-family: "Roboto", "Arial", sans-serif;
      font-weight: 300;
      display: inline-block;
      color: #000;
      background: $cloud;
      letter-spacing: 0.5px;
      font-size: 15px;
      border-radius: 3px;
      line-height: 36px;
      height: 36px;
      padding: 0 10px;
      text-decoration: none !important;
      outline: 0;
      border: 0;
      -webkit-tap-highlight-color: transparent;
      vertical-align: middle;
      text-transform: uppercase;
      box-shadow: 2px 3px 5px rgba(0, 0, 0, 0.15);
      transition: all 0.3s ease;
      &:focus {
        outline: none;
      }
      &:hover {
        background: $cloud;
      }
      &:active {
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.15);
      }
    }
  }
  &__wrapper {
    position: absolute;
    background-color: #fff;
    top: 50px;
    left: 0;
    z-index: 100;
    opacity: 0.5;
    max-height: 0px;
    max-width: 0px;
    overflow: hidden;
    border-radius: 30%;
    box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.15);
  }
  &__calendar {
    font-size: 0px;
    display: block;
    flex-wrap: wrap;
    padding: 0 20px 20px;
    max-width: 320px;
    user-select: none;
    box-sizing: border-box;
    &_days {
      display: flex;
      flex-wrap: wrap;
      //Day
      &_day {
        transition: all 0.3s ease;
        background-color: #f7fafc;
        position: relative;
        vertical-align: top;
        display: inline-block;
        line-height: 40px;
        width: 40px;
        text-align: center;
        height: 40px;
        font-size: 14px;
        cursor: pointer;
        font-weight: 500;
        user-select: none;
        &:hover {
          background-color: $cloud;
        }
        &-empty {
          display: inline-block;
          line-height: 40px;
          width: 40px;
          text-align: center;
          height: 40px;
          font-size: 16px;
          cursor: pointer;
        }
        &.active {
          background-color: $mainColor;
          color: #fff;
          border: 0px;
        }
        &.between {
          background: rgba(83, 123, 219, 0.8);
          color: #ffffff;
          box-sizing: border-box;
          position: relative;
          border-radius: 0;
          border: 0px;
        }
        &.disabled {
          pointer-events: none;
          color: #a3acb9;
          cursor: default;
        }
      }
    }
    &_head {
      font-size: 14px;
      color: #3c4257;
      text-align: center;
      padding: 10px 0;
      height: 42px;
      box-sizing: border-box;
      line-height: 10px;

      &_wday {
        line-height: 25px;
        color: #fff;
        display: block;
        width: 100%;
        font-size: 12px;
        background: rgba(0, 0, 0, 0.2);
        text-transform: uppercase;
        font-weight: 300;
      }
      &_month {
        color: #202438;
        font-size: 16px;
        display: flex;
        justify-content: space-between;
        height: 30px;
        font-weight: 400;
        line-height: 20px;
        & > span {
          display: inline-block;
          min-width: 100px;
        }
      }
      .next,
      .prev {
        vertical-align: middle;
        font-weight: 300;
        cursor: pointer;
        color: #556cd6;
        transition: all 0.3s ease;
      }
    }
    //Month
    &_m {
      transition: all 0.3s ease;
      //week
      &_w {
        font-size: 0;
        &_n {
          width: 40px;
          height: 40px;
          line-height: 40px;
          font-size: 12px;
          text-align: center;
          color: #888;
          display: inline-block;
          border-radius: 50%;
        }
      }
    }
  }
}
</style>
